import { getRootUrl } from '@shared-config/rootUrl';
import { useTranslation } from 'react-i18next';
import { ModalStyled } from 'src/components';
import { useCopyToClipboard } from 'src/hooks';
import { localUrl } from 'src/utils';

interface Props {
  open: boolean;
  onClose: () => void;
  cartId: string;
  title: string;
}

export const SaveSuccessModal = ({ open, onClose, cartId, title }: Props) => {
  const { t } = useTranslation();
  const link = `${getRootUrl()}/get/${cartId}`;
  const copyToClipboard = useCopyToClipboard();

  const copyLink = () => copyToClipboard(link);

  return (
    <ModalStyled open={open} onClose={onClose} customMaxWidth={640} showCloseButton={false}>
      <div className='px-2 xs:px-4 pt-5 pb-4 sm:p-6 font-primary'>
        <div className='mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100'>
          <svg
            className='h-6 w-6 text-green-600'
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={2}
            stroke='currentColor'
            aria-hidden='true'
          >
            <path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
          </svg>
        </div>
        <div className='mt-3 text-center sm:mt-5'>
          <h3 className='heading-300 text-center'>
            {t('popup.your_list_is_ready_to_share')}
          </h3>
          <div className='mt-4 flex flex-col w-full items-center justify-center'>
            {title && (
              <p className='text-200 text-left max-w-lg w-full'>{title}</p>
            )}
            <div
              onClick={copyLink}
              className='group mt-2 grow flex flex-row flex-nowrap justify-center items-center rounded-md w-full max-w-lg'
            >
              <div className='flex sm:flex-row flex-col sm:flex-nowrap grow'>
                <div className='flex border-b-0 border-r-2 sm:border-b-2 items-center justify-center sm:border-r-0 border-2 border-primary sm:rounded-l sm:rounded-r-none rounded-t bg-primary hover:bg-primary-hover transition min-w-fit whitespace-nowrap py-2 px-2 hover:cursor-pointer'>
                  <span className='text-base font-bold text-white'>
                    {t('common.copy_link')}
                  </span>
                </div>
                <input
                  readOnly
                  type='text'
                  value={link}
                  className='w-full min-w-[280px] text-center sm:text-left bg-offWhite border-2 border-t-0 sm:border-t-2 sm:border-l-0 border-gray-200 border-r-2 xs:grow sm:rounded-r sm:rounded-l-none rounded-b text-primary-dark text-base font-secondary font-normal py-2 px-0.5 sm:px-3 transition group-hover:cursor-pointer group-hover:border-primary'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='mt-8 flex w-full flex-col flex-nowrap items-center gap-4 sm:flex-row-reverse sm:justify-start'>
          <a
            href={localUrl(`/share/${cartId}`)}
            className='button-primary h-12 w-full text-center sm:w-auto'
          >
            {t('popup.sharing_options')}
          </a>
          <a
            href={localUrl(`/get/${cartId}`)}
            className='button-secondary h-12 w-full text-center sm:w-auto'
          >
            {t('popup.view_list')}
          </a>
          <button
            type='button'
            onClick={onClose}
            className='button-secondary h-12 w-full sm:w-auto'
          >
            {t('popup.keep_editing')}
          </button>
        </div>
      </div>
    </ModalStyled>
  );
};
